module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 37
// module chunks = 0 1 2